import React from 'react';
import logo from 'assets/img/logo.png';
import { useToggle } from '../../hooks/useToggle'; // путь к вашим хукам
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock'; // путь к вашим хукам
import { useScrollThreshold } from '../../hooks/useScrollThreshold'; // путь к вашим хукам
import { scrollToId } from '../../utils/scrollToSection';
import { useScrollSpy } from '../../hooks/useScrollSpy'; // импортируем хук
import { useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
    { id: 'tutor', label: 'Главная' },
    { id: 'teacher', label: 'Обо мне' },
    { id: 'lesson', label: 'Занятия' },
    { id: 'courses', label: 'Курсы' },
    { id: 'review', label: 'Отзывы' },
    // Добавьте остальные секции, которые есть на странице
];

const Header: React.FC = () => {
    const [isMenuOpen, toggleMenu] = useToggle(false);
    const isScrolled = useScrollThreshold(50);
    useBodyScrollLock(isMenuOpen);

    const location = useLocation();
    const navigate = useNavigate();

    // Используем хук для отслеживания активной секции
    const activeSection = useScrollSpy(NAV_ITEMS.map(item => item.id), 100);

    // const handleScrollTo = (id: string) => {
    //     scrollToId(id);
    //     if (isMenuOpen) {
    //         toggleMenu(); // Закрываем мобильное меню после выбора
    //     }
    // };

    const handleScrollTo = (id: string) => {
        if (location.pathname === '/') {
            // Если на главной — скроллим
            scrollToId(id);
            if (isMenuOpen) toggleMenu();
        } else {
            // Если на другой странице — переходим на главную с параметром scrollTo
            navigate(`/?scrollTo=${id}`);
            if (isMenuOpen) toggleMenu();
        }
    };

    const handleLogoKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleScrollTo('offer');
        }
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="header-content">
                    <div
                        onClick={() => handleScrollTo('tutor')}
                        className="logo"
                        role="banner"
                        tabIndex={0}
                        aria-label="Логотип Rost-English"
                        onKeyDown={handleLogoKeyDown}
                    >
                        <div className="logo-icon">
                            <img src={logo} alt="Логотип Rost-English" />
                        </div>
                        <div className="logo-text">
                            <span className='logo-highlight'><strong>Julia</strong></span>
                            <span><strong>Rostokina</strong></span>
                        </div>
                    </div>

                    <nav className="nav" aria-label="Основная навигация">
                        <ul className="nav-links" role="menubar">
                            {NAV_ITEMS.map(({ id, label }) => (
                                <li key={id} role="none">
                                    <button
                                        type="button"
                                        role="menuitem"
                                        onClick={() => handleScrollTo(id)}
                                        aria-label={`Перейти к разделу ${label}`}
                                        className={activeSection === id ? 'active' : ''}
                                    >
                                        {label}
                                    </button>
                                </li>
                            ))}
                            {/* <li role="none">
                                <button
                                    type="button"
                                    className="cta-button"
                                    role="menuitem"
                                    onClick={() => handleScrollTo('footer')}
                                    aria-label="Перейти к разделу Связаться"
                                >
                                    Связаться
                                </button>
                            </li> */}
                        </ul>
                    </nav>

                    <button
                        type="button"
                        onClick={toggleMenu}
                        className="mobile-menu-btn"
                        aria-expanded={isMenuOpen}
                        aria-controls="mobile-menu"
                        aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
                    >
                        {isMenuOpen ? (
                            <svg
                                width="36"
                                height="36"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            <svg
                                width="36"
                                height="36"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        )}
                    </button>
                </div>

                {isMenuOpen && (
                    <div
                        id="mobile-menu"
                        className={`mobile-menu open`}
                        role="menu"
                        aria-label="Мобильная навигация"
                    >
                        <div className="logo-icon">
                            <img src={logo} alt="Логотип Rost-English" />
                        </div>
                        <nav className='mobile-nav'>
                            <ul className="mobile-nav-links" role="menubar">
                                {NAV_ITEMS.map(({ id, label }) => (
                                    <li key={id} role="none">
                                        <button
                                            type="button"
                                            role="menuitem"
                                            onClick={() => handleScrollTo(id)}
                                            aria-label={`Перейти к разделу ${label}`}
                                        >
                                            {label}
                                        </button>
                                    </li>
                                ))}
                                {/* <li role="none">
                                    <button
                                        type="button"
                                        className="mobile-cta"
                                        role="menuitem"
                                        onClick={() => handleScrollTo('contacts')}
                                        aria-label="Перейти к разделу Записаться"
                                    >
                                        Записаться
                                    </button>
                                </li> */}
                            </ul>
                        </nav>
                        <div className="copy">
                            <p>&copy; Rost-English. Все права защищены.</p>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
